// Colores y reglas de presentación de la agenda, tomados de la planilla
// original: el color de la casilla indica el estado del turno y el del
// profesional, la disciplina.

export const DIAS = [
  { key: 'Lun', label: 'Lunes' },
  { key: 'Mar', label: 'Martes' },
  { key: 'Mie', label: 'Miércoles' },
  { key: 'Jue', label: 'Jueves' },
  { key: 'Vie', label: 'Viernes' },
];

export const ESTADOS = {
  ocupado: { label: 'Ocupado', clase: 'bg-cyan-300 text-slate-900' },
  vacio: { label: 'Turno vacío', clase: 'bg-green-400 text-slate-900' },
  reservado: { label: 'Reservado', clase: 'bg-fuchsia-400 text-slate-900' },
  almuerzo: { label: 'Almuerzo', clase: 'bg-slate-400 text-slate-900' },
  no_disponible: { label: 'Terapeuta no disponible', clase: 'bg-slate-500 text-white' },
  sin_uso: { label: 'Consultorio vacío', clase: 'bg-white text-slate-500 dark:bg-slate-700 dark:text-slate-300' },
};

// Color nuevo pedido para la migración: hay un nombre en la agenda que no
// coincide con ningún paciente cargado en el sistema.
export const NO_ENCONTRADO = { label: 'No está cargado en el sistema', clase: 'bg-red-200 text-red-900 ring-2 ring-inset ring-red-500' };

// Kinesiología, Psicomotricidad y T.O. van separadas (pedido del 2026-10-22).
// La disciplina con las tres juntas es la de la agenda importada: se sigue
// pintando, pero ya no se ofrece para elegir.
export const DISCIPLINAS = [
  { key: 'Psicología', clase: 'bg-yellow-300 text-slate-900' },
  { key: 'Fonoaudiología', clase: 'bg-violet-500 text-white' },
  { key: 'Psicopedagogía', clase: 'bg-orange-400 text-slate-900' },
  { key: 'Kinesiología', clase: 'bg-blue-700 text-white' },
  { key: 'Psicomotricidad', clase: 'bg-sky-400 text-slate-900' },
  { key: 'Terapia Ocupacional (T.O.)', clase: 'bg-teal-600 text-white' },
];
export const DISCIPLINA_AGRUPADA = { key: 'Kinesiología / Psicomotricidad / T.O.', clase: 'bg-blue-300 text-slate-900' };

export function claseDisciplina(disciplina) {
  return [...DISCIPLINAS, DISCIPLINA_AGRUPADA].find((d) => d.key === disciplina)?.clase || 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200';
}

export function tieneNoEncontrados(turno) {
  return (turno?.pacientes || []).some((p) => !p.patientId);
}

export function claseTurno(turno) {
  if (tieneNoEncontrados(turno)) return NO_ENCONTRADO.clase;
  return (ESTADOS[turno?.estado] || ESTADOS.vacio).clase;
}

const pad2 = (n) => String(n).padStart(2, '0');

export function fechaLocalIso(date = new Date()) {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

export function sumarDias(fecha, dias) {
  const date = new Date(`${fecha}T00:00:00Z`);
  if (Number.isNaN(date.getTime())) return fecha;
  date.setUTCDate(date.getUTCDate() + dias);
  return date.toISOString().slice(0, 10);
}

export function formatearFecha(fecha) {
  const date = new Date(`${fecha}T00:00:00Z`);
  if (Number.isNaN(date.getTime())) return fecha;
  const dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  const [anio, mes, dia] = fecha.split('-');
  return `${dias[date.getUTCDay()]} ${dia}/${mes}/${anio}`;
}

export function nombreVisible(paciente) {
  return paciente?.paciente || paciente?.nombre || '';
}

// Filas de la planilla del día: un renglón por paciente y turno, en el orden
// de la agenda (consultorio, hora).
export function filasPlanillaDia(consultorios) {
  const filas = [];
  (consultorios || []).forEach((c) => {
    c.turnos
      .filter((t) => (t.pacientes || []).length)
      .sort((a, b) => a.hora.localeCompare(b.hora))
      .forEach((t) => {
        t.pacientes.forEach((p) => filas.push({ consultorio: c.nombre, turno: t, paciente: p }));
      });
  });
  return filas;
}

const celdaCsv = (valor) => `"${String(valor ?? '').replace(/"/g, '""')}"`;

export function planillaDiaCsv({ sede, fecha, consultorios, asistencias }) {
  const estados = new Map((asistencias || []).map((a) => [`${a.consultorio}|${a.hora}|${a.nombre}`, a.estado]));
  const lineas = [['Centro', 'Fecha', 'Consultorio', 'Hora', 'Profesional', 'Paciente', 'Asistencia'].map(celdaCsv).join(',')];
  filasPlanillaDia(consultorios).forEach(({ consultorio, turno, paciente }) => {
    const nombre = nombreVisible(paciente);
    lineas.push([sede, fecha, consultorio, turno.hora, turno.profesional, nombre,
      estados.get(`${consultorio}|${turno.hora}|${nombre}`) || ''].map(celdaCsv).join(','));
  });
  return `﻿${lineas.join('\r\n')}\r\n`;
}
